import { render, staticRenderFns } from "./BusinessTypeClients.vue?vue&type=template&id=a54341ac&"
import script from "./BusinessTypeClients.vue?vue&type=script&lang=js&"
export * from "./BusinessTypeClients.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTypeClients.vue?vue&type=style&index=0&id=a54341ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports